import React, { useContext } from 'react';
import { Form, Input } from 'antd';
import { Button } from '../../components/ui/button';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AppContext } from '../../hooks/AppProvider';
import { useLogin } from '../../hooks/useAuth';

const FormWrapper = styled.div`
  width: 400px;
  margin: auto;
  margin-top: 50px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  h2,
  h5 {
    text-align: center;
    margin: 0px 0px 8px 0px;
  }
  h5 {
    margin: 0px 0px 2em 0px;
  }
`;

interface IForm {
  email: string;
  password: string;
}

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(AppContext);

  const navToForgotPwd = () => {
    navigate('/forgot-password');
  };

  const { mutate, isPending, contextHolder } = useLogin({
    navigate,
    setUser,
  });

  const onSubmit = (values: IForm) => {
    const { password, email } = values;
    if (!password || !email) {
      return;
    }

    mutate({ email, password });
  };

  return (
    <>
      {contextHolder}

      <FormWrapper>
        <h2>Sign In</h2>
        <h5>
          Don&apos;t have an account? <Link to={'/register'}>Sign Up</Link>
        </h5>
        <Form
          name="signup"
          onFinish={onSubmit}
          initialValues={{ remember: true }}
          scrollToFirstError
          disabled={isPending}
        >
          <Form.Item
            name="email"
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
          >
            <Input
              prefix={<MailOutlined className="site-form-item-icon" />}
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button variant="default" className="mr-2" disabled={isPending}>
              {isPending ? 'Logging in...' : 'Login'}
            </Button>
            <Button
              variant="outline"
              onClick={navToForgotPwd}
              disabled={isPending}
            >
              Forgot Password
            </Button>
          </Form.Item>
        </Form>
      </FormWrapper>
    </>
  );
};
